$(() => {
  const $snackBar = $('[data-js-snack-bar]');

  /**
   * jQuery plugin for a Race Roster event store item.
   * @param options
   * @returns {*}
   */
  $.fn.storeItem = function store(options) {
    const defaults = {
      displayInventory: false,
      i18n: {
        tooMany: '',
        tooManyUnspecified: '',
      },
      selectors: {
        itemForm: '[data-ja-store-item-information]',
        imageCarouselStage: '.js-store-item-image-carousel-stage',
        imageCarousel: '.js-store-item-image-carousel',
        options: '[data-js-store-item-selected-options]',
        option: '[data-js-store-item-selected-option]',
        optionQuantity: '[data-js-option-quantity]',
        removeOption: '.js-store-item-selected-option-remove',
        addOption: '.js-store-item-add-selected-option',
        optionSelect: '[data-js-option-select]',
        submitButton: '[data-js-store-item-submit]',
        totalItemInventory: '[data-js-total-item-inventory]',
        optionQuantityAvailable: '[data-js-option-quantity-available]',
      },
    };

    const initializeImageCarousel = (settings) => {
      const $imageCarouselStage = settings.elements.$store
        .find(settings.selectors.imageCarouselStage);
      const $imageCarousel = settings.elements.$store.find(settings.selectors.imageCarousel);

      $imageCarouselStage.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: settings.selectors.imageCarousel,
        infinite: false,
        fade: true,
      });

      $imageCarousel.slick({
        slidesToShow: 5,
        asNavFor: settings.selectors.imageCarouselStage,
        focusOnSelect: true,
        infinite: false,
      });
    };

    /**
     * We don't want this product option anymore
     * @param event
     * @param settings
     */
    const removeOption = (event, settings) => {
      const $this = $(event.currentTarget);

      $this.closest(settings.selectors.option).remove();
    };

    /**
     * Let's add a new option. Loads it from a prototype and replaces index with new ones based
     * off the index of the last option in the table. If there aren't any options in the table, it
     * just starts at 0.
     * @param event
     * @param settings
     */
    const addOption = (event, settings) => {
      const $optionChildren = settings.elements.$options.find(settings.selectors.option);
      const lastIndex = $optionChildren.length
        ? settings.elements.$options.find(settings.selectors.option).last().data('selected-option-index')
        : -1;
      const newItemPrototype = settings.elements.optionPrototype
        .replace(/__selectedOptionIndex0__/g, lastIndex + 1)
        .replace(/__selectedOptionIndex__/g, lastIndex + 2);

      settings.elements.$options.append($(newItemPrototype));
    };

    const getOptionAvailability = (event, settings) => {
      const $this = $(event.currentTarget);
      const $optionQuantityInput = $this
        .closest(settings.selectors.option)
        .find(settings.selectors.optionQuantity);
      const optionQuantityAvailable = $this.find('option:selected').data('js-option-quantity');

      $optionQuantityInput.attr('max', optionQuantityAvailable);
    };

    const isSelectedOptionQuantityLessThanAvailable = (settings, $selectedOptionRow) => {
      const $selectedOption = $selectedOptionRow.find(settings.selectors.optionSelect).find(':selected');

      if (!$selectedOption[0].hasAttribute('data-option-quantity-available')) {
        return true;
      }

      const $selectedQuantity = $selectedOptionRow.find(settings.selectors.optionQuantity).val();

      const optionQuantityAvailable = parseInt($selectedOption.attr('data-option-quantity-available'), 10);
      const optionQuantitySelected = parseInt($selectedQuantity, 10);

      return optionQuantitySelected <= optionQuantityAvailable;
    };

    const isTotalSelectedInventoryLessThanTotalInventoryAvailable = (settings) => {
      if (!settings.elements.$totalItemInventory.length) {
        return true;
      }

      const totalInventory = parseInt(settings.elements.$totalItemInventory.attr('data-js-total-item-inventory'), 10);
      const totalAdded = settings.elements.$store
        .find(settings.selectors.optionQuantity)
        .get()
        .reduce((accumulator, element) => accumulator + parseInt($(element).val(), 10), 0);

      return totalAdded <= totalInventory;
    };

    const submit = (event, settings) => {
      const $selectedOptions = settings.elements.$store.find(settings.selectors.option);

      $selectedOptions.each((index, element) => {
        if (!isSelectedOptionQuantityLessThanAvailable(settings, $(element))) {
          event.preventDefault();

          $snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: settings.i18n.tooManyUnspecified,
          });
          settings.elements.$itemForm.preventDoubleSubmission('reEnable');
        }
      });

      if (!isTotalSelectedInventoryLessThanTotalInventoryAvailable(settings)) {
        event.preventDefault();

        $snackBar.snackBar('add', {
          type: 'danger',
          icon: 'exclamation-circle',
          content: settings.displayInventory
            ? settings.i18n.tooMany.replace(
              '%total%',
              settings.elements.$totalItemInventory.attr('data-js-total-item-inventory'),
            )
            : settings.i18n.tooManyUnspecified,
        });
        settings.elements.$itemForm.preventDoubleSubmission('reEnable');
      }
    };

    /**
     * Fire up
     */
    const initialize = ($store) => {
      const settings = $.extend(true, {}, defaults, options);
      const $itemForm = $store.find(settings.selectors.itemForm);
      const $options = $store.find(settings.selectors.options);
      const $initialOption = $store.find(settings.selectors.option);
      const $submitButton = $store.find(settings.selectors.submitButton);
      const $optionSelect = $store.find(settings.selectors.optionSelect);
      const $initialOptionQuantityInput = $initialOption
        .closest(settings.selectors.option)
        .find(settings.selectors.optionQuantity);
      const $initialOptionQuantityAvailable = $initialOption.find('option:selected').data('js-option-quantity');

      settings.elements = {
        $store,
        $options,
        $itemForm,
        optionPrototype: $options.data('selected-option-prototype'),
        $totalItemInventory: $store.find(settings.selectors.totalItemInventory),
      };

      initializeImageCarousel(settings);

      $initialOptionQuantityInput.attr('max', $initialOptionQuantityAvailable);
      $store.on('change', settings.selectors.optionSelect, (event) => getOptionAvailability(event, settings));

      $store.on('click', settings.selectors.removeOption, (event) => removeOption(event, settings));
      $store.on('click', settings.selectors.addOption, (event) => addOption(event, settings));

      // toggle Add to cart button if no options are selected
      $store.on('change', settings.selectors.optionSelect, () => {
        if ($optionSelect.val() !== null) {
          $submitButton.removeClass('d-none');
        }
      });

      $itemForm.on('submit', (event) => submit(event, settings));
    };

    return this.each((index, element) => initialize($(element)));
  };
});
